<template>
	<div class="col-span-4">
		<!-- Header -->
		<div class="flex items-center justify-between mb-4">
			<h2 class="text-2xl font-bold dark:text-white">
				{{ t('dashboard.my-equipment.title') }}
			</h2>
		</div>

		<!-- Empty State -->
		<div
			v-if="macs.length === 0"
			class="flex flex-col items-center justify-center p-8 bg-white shadow dark:bg-mx-green-700 rounded-xl"
		>
			<p class="text-lg text-mx-gray-500 dark:text-mx-gray-400">
				{{ t('dashboard.my-equipment.no-devices') }}
			</p>
		</div>

		<!-- Equipment Grid -->
		<div
			v-else
			class="grid grid-cols-1 gap-6 md:grid-cols-2"
		>
			<AccountEquipmentGroup
				v-for="mac in macs"
				:key="mac.macAddress"
				:mac-address="mac.macAddress"
				:device-name="mac.deviceName"
				:serial-number="mac.serialNumber"
				:device-nms="detectDeviceNms(mac)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { detectDeviceNms } from '@/utils/equipment/nmsDetection'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { accountEquipment } = useAuth()

const macs = computed(() => accountEquipment.value || [])
</script>
